import Image from "~/components/ui/Image";
import type { Product } from "@decocms/apps-commerce/types";
import Slider from "~/components/ui/Slider";
import SliderJS from "~/components/ui/SliderJS";
import { useId } from "react";
import ProductItemCategories from "./ProductItemCategories";
import ShelfDots from "./ShelfDots";
import type { ManualSimplifiedProduct } from "./shelfTypes";

export interface Props {
  products?: Product[] | null;
  automatic: boolean;
}

export type { ManualSimplifiedProduct };

function TabCategorieShelf({ products, automatic: _automatic }: Props) {
  const id = useId();

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div
      id={id}
      className="h-full w-full flex lg:ml-0 lg:w-[100%] relative flex-col mb-6"
    >
      <Slider className="carousel carousel-center lg:flex gap-2 md:gap-6 col-span-full row-start-2 row-end-5 h-full w-full sm:carousel-end overflow-y-hidden max-w-[94vw] max-h-full lg:overflow-y-hidden list-categories">
        {products.map((product, index) => (
          <ProductItemCategories {...{ product, index }} />
        ))}
      </Slider>
      <>
        <div className="absolute hidden lg:block z-10 col-start-1 row-start-3 left-[30px] lg:left-6 top-[50%]">
          <Slider.PrevButton className="absolute right-1/2 bg-white h-[30px] w-[30px] flex justify-center items-center rounded-full border border-solid border-[#f9f9f9]">
            <Image
              loading="lazy"
              fetchPriority="low"
              decoding="async"
              width={12}
              height={23}
              src={"https://decoims.com/danielatombini/8fd8f8e4-9e5e-4d61-b837-d36704dd7994/home_slick-arrow.png"}
              alt="Previous item"
            />
          </Slider.PrevButton>
        </div>
        <div className="absolute hidden lg:block z-10 col-start-3 row-start-3 right-[30px] lg:right-6 top-[50%]">
          <Slider.NextButton className="absolute left-1/2 bg-white h-[30px] w-[30px] flex justify-center items-center rounded-full border border-solid border-[#f9f9f9] rotate-180">
            <Image
              loading="lazy"
              fetchPriority="low"
              decoding="async"
              width={12}
              height={23}
              src={"https://decoims.com/danielatombini/8fd8f8e4-9e5e-4d61-b837-d36704dd7994/home_slick-arrow.png"}
              alt="Next item"
            />
          </Slider.NextButton>
        </div>
      </>
      <div className="block lg:hidden col-start-2 row-start-5 m-auto lg:mt-4 bullets">
        <ShelfDots products={products} />
      </div>
      <SliderJS rootId={id} infinite />
    </div>
  );
}

export default TabCategorieShelf;
